import { useEffect, useMemo, useState } from "react"
import { Button } from "../ui/Button"
import  Map  from "../ui/MapComponent"
import { Slider } from "../ui/Slider"
import  Pagination  from "../../components/elements/pagination/pagination"
import { ServiceStation } from "./serviceStation"
import { RadioGroup } from "../ui/Radio"
import { useServiceCarStore } from "../../store/serviceCarStore"
import { useQuery } from "@tanstack/react-query"
import { getAvaliableAuthorizedLocations } from "../../transactions/serviceBooking/serviceBooking"

export const ServiceBooking = ({ setFormStep, handleBookingSubmit, bookingInfo, hasAuth }) => {
    const [items, setItems] = useState([]);
    const [selected, setSelected] = useState();
    const [currentPage, setCurrentPage] = useState(1);
    const [mapBounds, setMapBounds] = useState();
    const [sliderValue, setSliderValue] = useState(1);
    const [dislayedItems, setDisplayedItems] = useState([])
    const [totalItems, setTotalItems] = useState(0)
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    

    const { carInfo } = useServiceCarStore();

    const { status  } = useQuery({
        queryFn: () => getAvaliableAuthorizedLocations(carInfo.plateno),
        onSuccess: (data) => {
            setItems(data.data.locations);
        },
        enabled: hasAuth
    })

    useEffect(() => {
        const handleResize = () => {
          setWindowWidth(window.innerWidth);
        };
    
        // Add event listener for resize
        window.addEventListener('resize', handleResize);
    
        // Clean up by removing the event listener
        return () => {
          window.removeEventListener('resize', handleResize);
        };
      }, []);

    useEffect(() => {
        if (bookingInfo !== undefined && !hasAuth) {
            let itemsList = [];
            Object.entries(bookingInfo.bookingSelect.options).map(([key,value]) => { itemsList.push({ ...value, value: key }) })
            setItems(itemsList);
        }
    }, [bookingInfo, hasAuth])

    useEffect(() => {
        let displayList = [];
        if (items.length > 0 && mapBounds) {
            const perPage = hasAuth ||windowWidth<990 ?4:6
        
            const copyList = [...items];
            const filteredMarkers = copyList.filter(
                (marker) =>
                  mapBounds.contains(new window.google.maps.LatLng(marker.coordinates))
              );
            const startIndex = (currentPage - 1) * perPage;
            const endIndex = startIndex + perPage;
            setTotalItems(filteredMarkers.length)
            filteredMarkers.slice(startIndex, endIndex).map((item) =>
                displayList.push(item))
        }
        setDisplayedItems(displayList)
    }, [currentPage, items, mapBounds])

    useEffect(() => {
        if (mapBounds) {
            setCurrentPage(1)
        }
    }, [mapBounds])
    
    const estimateRadiusInMeters = useMemo(() => {
     
            // The Earth's radius in meters
            const baseRadius = 156543.03392; // meters per pixel

            // Calculate the radius at the given zoom level
            const radius = baseRadius / Math.pow(2, (15 - 1 * (sliderValue)))
          
            return radius.toFixed(0);
          
    },[sliderValue])

    return (
        <div className="gap-5 flex max-lg:flex-col justify-center mb-10">
            <div>
                <Map bookingSelect={hasAuth? {options:{...items}} :bookingInfo.bookingSelect} sliderValue={sliderValue} setMapBounds={setMapBounds} setSliderValue={setSliderValue} />
                <div className="bg-white rounded-b-[12px] flex flex-col gap-6 py-3 px-5">
                <div className="flex justify-between items-center">
                    <h4>Προτιμώμενη απόσταση</h4>
                    <div className="flex border border-[#595454] rounded-[10px] h5 p-[10px] justify-end">
                        {estimateRadiusInMeters} χλμ
                    </div>
                </div>
                <div className="w-full pb-10">
                    <Slider value={[sliderValue]} onValueChange={(value)=> setSliderValue(value[0])} defaultValue={[1]} min={1} max={10} step={1} />
                </div>
            </div>
            </div>
            <div className="flex flex-col gap-6 relative min-w-[35vw]">
                {!hasAuth && <div className="max-lg:w-full max-lg:my-5 order-last lg:absolute flex max-lg:flex-col-reverse gap-4 lg:gap-10 lg:-top-[60px] lg:right-0">
                    <Button className={'border border-[#A5A5A5] py-3 px-10 rounded-[6px] text-primary-button'} onClick={() => { setFormStep(0) }}>Ακύρωση</Button>
                    <Button disabled={!selected} onClick={() => handleBookingSubmit(selected)} className={'disabled:bg-[#A5A5A5] rounded-[6px] bg-[#D4002A] py-3 px-10 text-primary-button text-white'}>Επόμενο</Button>
                </div>
                }
                <h4>Διαθέσιμοι σταθμοί εξυπηρέτησης</h4>
                {!hasAuth ?
                    <RadioGroup
                    className="grid lg:grid-cols-2 gap-5"
                    onValueChange={setSelected}
                    >
                        {dislayedItems.length === 0 ? <p className="grid col-span-2">Δεν υπάρχουν διαθέσιμοι σταθμοί σε αυτή την περιοχή. Χρησιμοποίησε τον χάρτη για να βρεις έναν διαθέσιμο σταθμό.</p>
                            : dislayedItems.map((station, index) =>
                            <ServiceStation station={station} key={index} />
                        )}
                    </RadioGroup> :
                    <div className="grid grid-cols-2 gap-5">
                        {status === 'loading' && 
                            Array.from({ length: 3 }, (_, index) =>
                                <div className={'py-6 px-4 bg-white flex flex-col gap-2 rounded-[12px] animate-pulse'}>
                                    <div className="w-full flex justify-between">
                                        <div className="w-20 h-5  bg-powdergrey  rounded-full" />
                                        <div className="w-10 h-5  bg-powdergrey  rounded-full" />
                                    </div>
                                    <div className="w-40 h-5 bg-powdergrey  rounded-full" />
                                    <div className="w-40 h-5 bg-powdergrey  rounded-full"/>
                                    <div className="w-40 h-5 bg-powdergrey  rounded-full" />
                                    <div className="w-40 h-5 bg-powdergrey  rounded-full"/>
                            </div>)
                        }
                        {dislayedItems.length === 0 && status !== 'loading' ? <p className="grid col-span-2">Δεν υπάρχουν διαθέσιμοι σταθμοί σε αυτή την περιοχή. Χρησιμοποίησε τον χάρτη για να βρεις έναν διαθέσιμο σταθμό.</p>
                            :dislayedItems.map((station, index) =>
                           <ServiceStation hasAuth={hasAuth} station={station} key={index} />
                        )}
                    </div>
                }
                <Pagination
                    currentPage={currentPage}
                    totalCount={totalItems}
                    pageSize={hasAuth || windowWidth <= 990 ? 4 : 6}
                    onPageChange={setCurrentPage}
                />
            </div>
        </div>
    )
}